import 'twin.macro';
import { useCountryConfig } from 'queries/user/useCountryConfig';
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useEleves from '@teetsh/app/src/queries/eleves/useEleves';
import SpinnerComponent from '@teetsh/app/src/components/Spinner/ScreenSpinner';
import { ClassroomsProvider } from '@teetsh/app/src/containers/App/context/ClassroomsContext';
import useClassrooms from '@teetsh/app/src/containers/App/context/ClassroomsContext/useClassrooms';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { getDayBasedOnWorkingDays } from '@teetsh/app/src/utils/time';
import { getMutualWorkingDays } from '@teetsh/app/src/containers/utils';
import { format } from '@teetsh/app/src/utils/time/format';
import { Header } from '@teetsh/app/src/containers/RegistreAppel/Header';
import { LimitReached } from '@teetsh/app/src/components/LimitReached';
import { isoDatePatternWithSlashes } from 'utils/time/datePatterns';
import { EmptyModule } from 'components/EmptyModule';
import SchoolyearButtonLink from 'components/Buttons/SchoolyearButtonLink';
import { PlusIcon as Plus } from '@heroicons/react/24/outline';
import { screenshotUrls } from 'containers/screenshotUrls';
import { useTranslation } from 'react-i18next';

export function RedirectToCurrentDay() {
  const classrooms = useClassrooms();
  const { school, schoolyear } = useSchoolSchoolyear();
  const day = getDayBasedOnWorkingDays(
    new Date(),
    getMutualWorkingDays(classrooms),
  );
  return (
    <Navigate
      to={`/annee-scolaire/${schoolyear.id}/ecole/${
        school.id
      }/registre-appel/appels/${format(
        day,
        'fr-FR',
        isoDatePatternWithSlashes,
      )}`}
      replace
    />
  );
}

export default function RegistreAppelRoot() {
  const { data, isLoading, isSuccess } = useEleves();
  const { t } = useTranslation(['registreAppel', 'common']);
  const { isIllustrationEnabled } = useCountryConfig();

  if (isLoading || !isSuccess || !data) {
    return <SpinnerComponent />;
  }

  if (data.length === 0) {
    return (
      <EmptyModule
        title={t('registreAppel:welcomeTitle')}
        subtitle={t('registreAppel:welcomeSubtitle')}
        imageUrl={
          isIllustrationEnabled ? screenshotUrls.registreAppel : undefined
        }
        cta={
          <SchoolyearButtonLink
            intent="primary"
            extralarge
            to="eleves/import?redirect=registre-appel"
            icon={Plus}
          >
            {t('registreAppel:createRegistre')}
          </SchoolyearButtonLink>
        }
      />
    );
  }

  return (
    <ClassroomsProvider>
      <LimitReached item="appel" />
      <Header />
      <Outlet />
    </ClassroomsProvider>
  );
}
